import { cn } from '#app/utils/misc'
import { BigHeading } from '../primitives'

/**
 * The screen title: a medium eyebrow ("Sign In As A") over the big
 * condensed line ("Tenant."). One h1, two spans, so screen readers hear the
 * whole sentence. The big line is vh-clamped on desktop, 56px on tablets,
 * 46px on phones and 38px on short phones (auth.css).
 */
export function AuthHeading({
	eyebrow,
	title,
	className,
}: {
	eyebrow: string
	title: string
	className?: string
}) {
	return (
		<h1
			className={cn(
				'tt-auth-heading mb-[18px] min-[901px]:mb-[clamp(18px,3.4vh,34px)]',
				className,
			)}
		>
			<span className="mb-1 block text-[15px] font-medium tracking-[-.005em] text-tt-body min-[601px]:mb-[clamp(6px,1vh,12px)] min-[601px]:text-[clamp(17px,1.4vw,20px)]">
				{eyebrow}
			</span>{' '}
			<BigHeading
				as="span"
				className="tt-auth-heading-big block text-[46px] text-tt-ink min-[601px]:text-[56px] min-[901px]:text-[clamp(56px,min(6.4vw,10vh),104px)]"
			>
				{title}
			</BigHeading>
		</h1>
	)
}
